import { create } from "zustand";

const useStore = create((set) => ({
  isAuth: null,
  setIsAuth: (isAuth) => set({ isAuth }),
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
}));

export default useStore;
